import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { PlatformService } from '@rma/generic/util/environment';
import { RESPONSE } from '@rma/generic/util/server';
import { StarRatingComponent } from '@rma/reviews/public/ui-rating';
import { type Response } from 'express';
import { filter, map } from 'rxjs';
import { ErrorCardStyle } from '../domain/error-message';

@Component({
  selector: 'rma-not-found',
  imports: [AsyncPipe, RouterModule, MatButtonModule, TranslocoModule, StarRatingComponent],
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('fallbackPages')],
})
export class NotFoundComponent implements OnInit {
  @HostBinding()
  public readonly class = ErrorCardStyle;

  private readonly platformService = inject(PlatformService);
  private readonly response: Response | null = inject(RESPONSE, { optional: true });
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected readonly showBackButton$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    map(() => this.route.snapshot.data['hideBackButton'] ?? false),
    map((hideBack) => !hideBack),
  );

  public ngOnInit(): void {
    if (this.platformService.isPlatformServer && this.response) {
      this.response.status(404);
    }
  }
}
